<script>
import Intro from './Intro.svelte';
import Camera from './Camera.svelte';
import Creds from './Creds.svelte';
import Compare from './Compare.svelte';

import { route } from './stores';
</script>

<div class="MyID">
	{#if $route == 'camera'}
		<Camera />
	{:else if $route == 'creds'}
		<Creds />
	{:else if $route == 'compare'}
		<Compare />
	{:else}
		<Intro />
	{/if}
</div>

<style>
.MyID {
	display: flex;
	justify-content: stretch;
	align-items: stretch;
	/*box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);*/
	overflow: hidden;
	position: relative;
	width: 100%;
	flex-grow: 1;
	color: white;
}
.MyID > :global(*) {
	width: 100%;
}
</style>